var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Report',{attrs:{"module":"Cliente","name":"Contato","urlGet":"/api/v1/crm/report/contact","header":_vm.header,"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }